module.exports = __webpack_public_path__ + "img/125.3.88de73ef.png";